import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { SearchPatientComponent } from './search-patient.component';

const requestAppointmentRoutes: Routes = [
  { path: '', component: SearchPatientComponent }
];

@NgModule({
  imports: [
    RouterModule.forChild(requestAppointmentRoutes)
  ],
  exports: [
    RouterModule
  ],
  providers: []
})

export class SearchPatientRoutingModule { }



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/search-patient/search-patient.routing.ts